module.exports = __webpack_public_path__ + "static/media/red-heart.a495b010.svg";